
/* =====================================================
   MORE COLORS – ARROW CONTROL (SAFE)
===================================================== */

(function () {

  function update(block) {
    const viewport = block.querySelector('.mc-viewport');
    const prev = block.querySelector('.mc-prev');
    const next = block.querySelector('.mc-next');
    const items = block.querySelectorAll('.mc-item');

    if (!viewport || !prev || !next) return;

    const max = viewport.scrollWidth - viewport.clientWidth;
    const isDesktop = window.innerWidth >= 768;
    const isMobile = window.innerWidth < 768;

    if ((isDesktop && items.length > 4) || (isMobile && items.length > 2)) {
      block.classList.add('has-arrows');
    } else {
      block.classList.remove('has-arrows');
    }

    prev.disabled = viewport.scrollLeft <= 0;
    next.disabled = viewport.scrollLeft >= max - 1;
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.mc-arrow');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const block = btn.closest('.mc-block');
    const viewport = block.querySelector('.mc-viewport');
    const item = block.querySelector('.mc-item');
    if (!viewport || !item) return;

    const gap = 10;
    const amount = item.offsetWidth + gap;

    viewport.scrollBy({
      left: btn.classList.contains('mc-prev') ? -amount : amount,
      behavior: 'smooth'
    });

    setTimeout(() => update(block), 250);
  });

  document.addEventListener('scroll', function (e) {
    const vp = e.target.closest && e.target.closest('.mc-viewport');
    if (!vp) return;
    const block = vp.closest('.mc-block');
    if (block) update(block);
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll('.mc-block').forEach(update);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mc-block').forEach(update);
  });

})();

